module.exports = __webpack_public_path__ + "static/media/ALUMINIO.7c32777a.png";